import React, { useEffect, useState } from "react";
import SingleInvite from "./SingleInvite";
import BulkInvite from "./BulkInvite";
import { TeamOutlined, UserAddOutlined } from "@ant-design/icons";

const tabs = [
  {
    id: "singleInvite",
    label: "Single Applicant Invite",
    icon: <UserAddOutlined />,
  },
  {
    id: "bulkInvite",
    label: "Bulk Invitations",
    icon: <TeamOutlined />,
  },
];

const InviteApplicant = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.id);

  useEffect(() => {
    const storedTab = localStorage.getItem("create-order-tab") || null;
    if (storedTab) {
      setActiveTab(storedTab);
    }
  }, []);

  return (
    <div>
      <ul className="invite-tabs">
        {tabs.map((tab) => (
          <li key={tab.id}>
            <button
              type="button"
              className={`invite-btn d-inline-flex align-items-center gap-2 ${
                activeTab === tab.id ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab(tab.id);
                localStorage.setItem("create-order-tab", tab.id);
              }}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          </li>
        ))}
      </ul>
      <div className="mt-3 px-2">
        {activeTab == "singleInvite" && <SingleInvite />}
        {activeTab == "bulkInvite" && <BulkInvite />}
      </div>
    </div>
  );
};

export default InviteApplicant;